/**
 * 接口错误码信息字典
 */
export const errorMsgMap = {
  0: '网络异常，请稍后重试',
  1000: '操作失败，建议您刷新页面或稍后再试',
  1001: '名字已存在',
  1002: '名字不符合验证规则',
  1003: '描述不符合验证规则',
  1004: '数量超过总限额',
  1005: '数量超过限额，不能创建',
  1006: '用户余额不足',
  1007: '存在子网，无法删除VPC',
  1008: 'VPC删除失败，请联系客服',
  1009: 'IP已分配，无法删除子网',
  1010: '安全组规则已绑定，无法删除安全组',
  1011: '无法删除默认安全组',
  1012: '无法在该状态下进行删除',
  1013: '该状态无法进行修改',
  1014: '无法将该状态修改为另一个状态',
  1015: '该网段已被占用',
  1016: '无法使用硬盘快照进行创建',
  1017: '密码格式错误',
  1018: '用户名或密码错误',
  1019: '该端口范围的规则已存在',
  1020: '创建子网失败，网络地址不能重复',
  10201: '输入的地址段中有地址与私有网络或公网地址池地址交叉，请重新输入',
  1021: '网络地址范围与同组织的私有网络地址交叉',
  1022: '虚拟专有云在云上不存在或者与所创建网络不在同一组织',
  1023: '找不到组织映射关系',
  1024: '找不到云',
  1025: '未知错误',
  1026: '未找到订单信息',
  1027: '订单已取消或已支付',
  1028: '未找到账户信息',
  1029: '电子钱包余额不足',
  1030: '体验券不存在',
  1031: '体验券未激活',
  1032: '体验券不可用',
  1033: '电子钱包和体验券余额不足',
  1034: '支付错误',
  1035: '所选子网可用IP个数小于实例个数，请重新选择',
  11002: '自定义镜像数量超过总限额',
  11003: '创建自定义镜像失败，请检查主机状态并重试',
  11004: '云主机已过期，无法创建自定义镜像',
  11005: '云主机不存在',
  11006: '云主机已过期',
  12001: '操作失败，云硬盘不存在',
  12002: '操作失败，云硬盘不存在',
  12003: '挂载云硬盘失败，该云硬盘已挂载',
  12004: '卸载云硬盘失败，该云硬盘已卸载',
  12005: '挂载云硬盘失败，云硬盘不存在',
  12006: '云主机可挂载云硬盘数量超过总限额',
  12008: '操作失败，云硬盘已过期',
  12009: '操作失败，快照不存在',
  12010: '快照数量超过总限额',
  12011: '云硬盘可创建快照数量超过总限额',
  12012: '操作失败，请检查云硬盘状态是否正常',
  12013: '当前快照所属云硬盘已过期',
  13001: '操作失败，弹性公网IP不存在',
  13002: '绑定弹性公网IP失败，该弹性公网IP已绑定',
  13003: '解绑弹性公网IP失败，该弹性公网IP未绑定',
  13004: '弹性公网IP已过期',
  14001: '秘钥对不存在',
  14002: '无效的公钥',
  10001: '资源已过期',
  10002: '未找到该资源',
};
